import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "flex items-center h-5 pl-5 text-xs bg-primary-100 dark:bg-gray-600 text-primary-900 dark:text-gray-400"
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Subheader',
    setup(__props) {
        const retroStore = useRetroStore();
        const { isLoaded, teamId, retroName } = storeToRefs(retroStore);
        const isWorkspaceSubheaderVisible = computed(() => teamId.value !== null);
        return (_ctx, _cache) => {
            return (_unref(isLoaded))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(isWorkspaceSubheaderVisible))
                        ? (_openBlock(), _createBlock(WorkspaceSubheader, { key: 0 }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(retroName)), 1))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
